import flagsmith from '@flagsmith/flagsmith';
import { FlagsmithProvider } from '@flagsmith/flagsmith/react';
import React from 'react';

type props = {
  children: React.ReactNode;
};

export const CustomFlagsmithProvider = ({ children }: props) => {
  return <FlagsmithProvider flagsmith={flagsmith}>{children}</FlagsmithProvider>;
};
